var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Project from './Project.vue';
import ProjectMap from '../shared/ProjectMap.vue';
import Loader from '../shared/Loader.vue';
import ProjectDetails from './ProjectDetails.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Choices from 'choices.js';
import { scrollToElement } from '../../../utils/scroll-to';
const service = namespace('Service');
var FilterType;
(function (FilterType) {
    FilterType[FilterType["NONE"] = 0] = "NONE";
    FilterType[FilterType["SECTOR"] = 1] = "SECTOR";
    FilterType[FilterType["LOCATION"] = 2] = "LOCATION";
    FilterType[FilterType["PARTICIPATION"] = 3] = "PARTICIPATION";
    FilterType[FilterType["NAME"] = 4] = "NAME";
    FilterType[FilterType["PROVINCE"] = 5] = "PROVINCE";
})(FilterType || (FilterType = {}));
let ProjectList = class ProjectList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.data = [];
        this.filteredSectors = [];
        this.activeProjectId = 0;
        this.activeProject = {};
        this.activeFilterType = FilterType.NONE;
        this.activeSectorId = 0;
        this.activeLocationId = 0;
        this.activeProvinceId = 0;
        this.activeParticipationId = 0;
        this.activePartnershipNameId = 0;
        this.mapIsActive = false;
        this.isMobile = false;
        this.projectDetailClass = '';
        this.filterBySelect = null;
        this.sectorFilterSelect = null;
        this.locationFilterSelect = null;
        this.provincesFilterSelect = null;
        this.participationFilterSelect = null;
        this.partnershipNameFilterSelect = null;
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: ''
        };
        this.showOptions = this.propShowOptions;
        this.showMap = this.propShowMap;
        this.clickable = this.isClickable;
        this.featureProjectIdInternal = this.featureProjectId;
        this.allowScrollTo = false;
        this.partnershipNames = [
            { id: 1, title: "A-E", regex: /^[a-eA-E]/ },
            { id: 2, title: "F-J", regex: /^[f-jF-J]/ },
            { id: 3, title: "K-O", regex: /^[k-oK-O]/ },
            { id: 4, title: "P-T", regex: /^[p-tP-T]/ },
            { id: 5, title: "U-Z", regex: /^[u-zU-Z]/ },
        ];
    }
    created() {
        if (Vue.$cookies.get('mapIsActive') || this.showMap) {
            this.mapIsActive = Vue.$cookies.get('mapIsActive') === 'true' || this.showMap;
        }
        this.isMobile = window.innerWidth <= 1279;
        this.getProjectBrowserData({
            showOnHomepage: null,
            showOnPartnershipMap: true,
            siteId: window.cibbic.siteId,
            transform: 'relatedProjects',
        }).then(() => {
            if (this.featureProjectIdInternal !== 0) {
                setTimeout(() => {
                    this.onMapClick(this.featureProjectIdInternal);
                }, 1000);
            }
        });
    }
    mounted() {
        window.addEventListener('resize', (evt) => {
            this.isMobile = window.innerWidth <= 1279;
        });
        if (this.activeSector) {
            this.activeFilterType = FilterType.SECTOR;
            this.activeSectorId = this.activeSector;
        }
        const hashProperty = window.location.hash ? window.location.hash.replace('#', '').split('-')[0] : '';
        const initialFilterType = hashProperty === 'sector' ? FilterType.SECTOR
            : hashProperty === 'region' ? FilterType.LOCATION
                : hashProperty === 'province' ? FilterType.PROVINCE
                    : hashProperty === 'participation' ? FilterType.PARTICIPATION
                        : hashProperty === 'partnership' ? FilterType.NAME
                            : FilterType.NONE;
        this.filterBySelect = new Choices('#filterBy', Object.assign(Object.assign({}, this.selectProps), {
            choices: [
                { value: FilterType.NONE, label: this.labels.choose, selected: initialFilterType === FilterType.NONE },
                { value: FilterType.SECTOR, label: this.labels.sector, selected: initialFilterType === FilterType.SECTOR },
                { value: FilterType.LOCATION, label: this.labels.location, selected: initialFilterType === FilterType.LOCATION },
                { value: FilterType.PARTICIPATION, label: this.labels.participation, selected: initialFilterType === FilterType.PARTICIPATION },
                { value: FilterType.PROVINCE, label: this.labels.provinces, selected: initialFilterType === FilterType.PROVINCE },
                //{value: FilterType.NAME, label: this.labels.name},
            ],
            'labelId': 'filterByLabel'
        }));
        this.sectorFilterSelect = new Choices('#sectorFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'sectorFilterLabel' }));
        this.locationFilterSelect = new Choices('#locationFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'locationFilterLabel' }));
        this.provincesFilterSelect = new Choices('#provincesFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'provincesFilterLabel' }));
        this.participationFilterSelect = new Choices('#participationFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'participationFilterLabel' }));
        // this.partnershipNameFilterSelect = new Choices('#partnershipNameFilter', this.selectProps);
    }
    switchToMap(value) {
        this.mapIsActive = value;
        Vue.$cookies.set('mapIsActive', value.toString());
    }
    onFilterTypeChange(filterType) {
        this.activeFilterType = filterType;
        window.location.hash = '';
        this.resetFilters();
        this.resetDropdowns();
        this.scrollToProjects();
        this.filterData();
        this.filterActiveProject();
    }
    onSectorChange(_id) {
        this.onDropdownChange("activeSectorId", _id);
    }
    onLocationChange(_id) {
        this.onDropdownChange("activeLocationId", _id);
    }
    onProvinceChange(_id) {
        this.onDropdownChange("activeProvinceId", _id);
    }
    onParticipationChange(_id) {
        this.onDropdownChange("activeParticipationId", _id);
    }
    onPartnershipNameChange(_id) {
        this.onDropdownChange("activePartnershipNameId", _id);
    }
    onDropdownChange(property, _id) {
        var _a;
        this[property] = _id;
        const propertyToPrefix = {
            activeSectorId: 'sector',
            activeLocationId: 'region',
            activeProvinceId: 'province',
            activeParticipationId: 'participation',
            activePartnershipNameId: 'partnership',
        };
        const propertyToData = {
            activeSectorId: this.filteredSectors,
            activeLocationId: this.locations,
            activeProvinceId: this.provinces,
            activeParticipationId: this.participations,
            activePartnershipNameId: this.partnershipNames,
        };
        const prefix = propertyToPrefix[property];
        const item = (_a = propertyToData[property]) === null || _a === void 0 ? void 0 : _a.find((i) => i.id == _id);
        window.location.hash = (prefix && item) ? `${prefix}-${this.slugify(item.title)}` : '';
        this.scrollToProjects();
        this.filterData();
        this.filterActiveProject();
        this.allowScrollTo = true; // Allow scrolling after this
    }
    resetFilters() {
        this.activeSectorId = 0;
        this.activeLocationId = 0;
        this.activeProvinceId = 0;
        this.activeParticipationId = 0;
        this.activePartnershipNameId = 0;
    }
    resetDropdowns() {
        var _a, _b, _c, _d, _e;
        (_a = this.sectorFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoiceByValue(this.activeSectorId);
        (_b = this.locationFilterSelect) === null || _b === void 0 ? void 0 : _b.setChoiceByValue(this.activeLocationId);
        (_c = this.provincesFilterSelect) === null || _c === void 0 ? void 0 : _c.setChoiceByValue(this.activeProvinceId);
        (_d = this.participationFilterSelect) === null || _d === void 0 ? void 0 : _d.setChoiceByValue(this.activeParticipationId);
        (_e = this.partnershipNameFilterSelect) === null || _e === void 0 ? void 0 : _e.setChoiceByValue(this.activePartnershipNameId);
    }
    scrollToProjects() {
        if (!this.allowScrollTo)
            return;
        const projectList = this.$refs.projectlist;
        const padding = 50;
        if (window.scrollY < (projectList.offsetTop - padding)) {
            scrollToElement(this.$refs.projectlist, 600, padding);
        }
    }
    filterData() {
        let projects = this.projects;
        // Filter by sectors
        if (this.activeSectorId > 0) {
            projects = projects.filter((project) => {
                return project.sector.some((sector) => {
                    return sector.id === this.activeSectorId;
                });
            });
        }
        // Filter by locations
        if (this.activeLocationId > 0) {
            projects = projects.filter((project) => {
                return project.locationCategories.some((location) => {
                    return location.id === this.activeLocationId;
                });
            });
        }
        // Filter by provinces
        if (this.activeProvinceId > 0) {
            projects = projects.filter((project) => {
                return project.provinces.some((province) => {
                    return province.id === this.activeProvinceId;
                });
            });
        }
        // Filter by participations
        if (this.activeParticipationId > 0) {
            projects = projects.filter((project) => {
                return project.participationCategories.some((participation) => {
                    return participation.id === this.activeParticipationId;
                });
            });
        }
        // Filter by partnership names
        if (this.activePartnershipNameId > 0) {
            const nameRegex = this.partnershipNames.find(p => p.id === this.activePartnershipNameId).regex;
            projects = projects.filter((project) => {
                return nameRegex.test(project.title);
            });
        }
        this.data = this.sortProjects(projects);
    }
    filterActiveProject() {
        if (this.activeProject && !this.data.some((project) => {
            var _a;
            return ((_a = this.activeProject) === null || _a === void 0 ? void 0 : _a.id) === project.id;
        })) {
            this.removeProject();
        }
    }
    onMapClick(_id) {
        if (_id === this.activeProjectId)
            return;
        // @ts-ignore
        this.activeProjectId = _id.toString();
        console.log('this.activeProjectId:', this.activeProjectId);
        this.projectDetailClass = '';
        setTimeout(() => {
            this.activeProject = this.data.find((project) => {
                // @ts-ignore
                return project.id === _id.toString();
            });
            this.projectDetailClass = 'show';
        }, 150);
    }
    onMapClickWithFocus(_id) {
        if (_id === this.activeProjectId)
            return;
        this.activeProjectId = _id;
        this.projectDetailClass = '';
        setTimeout(() => {
            this.activeProject = this.data.find((project) => {
                return project.id === _id;
            });
            this.projectDetailClass = 'show';
        }, 150);
        setTimeout(() => {
            const projectDetails = this.$refs.projectDetailsComponent;
            projectDetails.$refs.closeButton.focus();
        }, 200);
    }
    removeProject() {
        setTimeout(() => {
            this.activeProject = {};
        }, 300);
        this.projectDetailClass = '';
        this.activeProjectId = 0;
    }
    removeProjectWithFocus(_projectId) {
        setTimeout(() => {
            this.activeProject = {};
        }, 300);
        this.projectDetailClass = '';
        this.activeProjectId = 0;
        const activeProjectTrigger = document.querySelector(`[data-projectId="${_projectId}"]`);
        activeProjectTrigger.focus();
    }
    sortProjects(projects) {
        return [...projects].sort((a, b) => a.title.localeCompare(b.title));
    }
    slugify(text) {
        return text.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }
    fillSectorsDropDown() {
        var _a;
        (_a = this.sectorFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.filteredSectors, this.activeSectorId, this.labels.all_sectors), 'value', 'label', true);
    }
    fillLocationsDropDown() {
        var _a;
        (_a = this.locationFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.locations, 0, this.labels.all_locations), 'value', 'label', true);
    }
    fillProvincesDropDown() {
        var _a;
        (_a = this.provincesFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.provinces, 0, this.labels.all_provinces), 'value', 'label', true);
    }
    fillParticipationsDropDown() {
        var _a;
        (_a = this.participationFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.participations, 0, this.labels.all_participations), 'value', 'label', true);
    }
    fillPartnershipNamesDropDown() {
        var _a;
        (_a = this.partnershipNameFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.partnershipNames, 0, this.labels.all_partnership_names), 'value', 'label', true);
    }
    getDropDownValues(values, activeValueId, label) {
        let tmp = values.map((i) => {
            return { value: i.id, label: i.title, selected: this.activeSectorId == i.id };
        });
        tmp.unshift({ value: 0, label: label, selected: this.activeSectorId === 0 });
        return tmp;
    }
    onDataChanged() {
        var _a;
        this.data = this.sortProjects(this.projects);
        if (this.activeSector) {
            this.onSectorChange(this.activeSector);
        }
        this.loading = false;
        // retrieve hash values
        const hash = window.location.hash;
        if (hash) {
            const hashStr = hash.replace('#', '');
            const dashIdx = hashStr.indexOf('-');
            if (dashIdx !== -1) {
                const prefix = hashStr.substring(0, dashIdx);
                const slug = hashStr.substring(dashIdx + 1);
                const prefixToProperty = {
                    sector: 'activeSectorId',
                    region: 'activeLocationId',
                    province: 'activeProvinceId',
                    participation: 'activeParticipationId',
                    partnership: 'activePartnershipNameId',
                };
                const property = prefixToProperty[prefix];
                if (property) {
                    const propertyToData = {
                        activeSectorId: this.sectors,
                        activeLocationId: this.locations,
                        activeProvinceId: this.provinces,
                        activeParticipationId: this.participations,
                        activePartnershipNameId: this.partnershipNames,
                    };
                    const item = (_a = propertyToData[property]) === null || _a === void 0 ? void 0 : _a.find((i) => this.slugify(i.title) === slug);
                    if (item) {
                        this[property] = item.id;
                        this.filterData();
                        this.filterActiveProject();
                        this.scrollToProjects();
                    }
                    if (prefix === 'sector')
                        this.activeFilterType = FilterType.SECTOR;
                    else if (prefix === 'region')
                        this.activeFilterType = FilterType.LOCATION;
                    else if (prefix === 'province')
                        this.activeFilterType = FilterType.PROVINCE;
                    else if (prefix === 'participation')
                        this.activeFilterType = FilterType.PARTICIPATION;
                    else if (prefix === 'partnership')
                        this.activeFilterType = FilterType.NAME;
                }
            }
        }
    }
    onSectorsChanged() {
        var _a, _b, _c, _d, _e, _f;
        const projectSectorIds = this.projects.flatMap(project => {
            return project.sector.flatMap(projectSector => {
                return projectSector.id;
            });
        });
        this.filteredSectors = this.sectors.filter(sector => {
            return projectSectorIds.includes(sector.id);
        });
        this.data.forEach(project => {
            project.sector.forEach(sector => {
                const exist = this.sectors.find((i) => {
                    return i.id === sector.id;
                });
                if (!exist) {
                    this.sectors.push(sector);
                }
            });
        });
        this.fillSectorsDropDown();
        this.fillLocationsDropDown();
        this.fillProvincesDropDown();
        this.fillParticipationsDropDown();
        this.fillPartnershipNamesDropDown();
        // sync Choices UI with hash-restored filter state
        const hash = window.location.hash;
        if (hash) {
            const hashStr = hash.replace('#', '');
            const dashIdx = hashStr.indexOf('-');
            if (dashIdx !== -1) {
                const prefix = hashStr.substring(0, dashIdx);
                const slug = hashStr.substring(dashIdx + 1);
                const prefixToData = {
                    sector: this.filteredSectors,
                    region: this.locations,
                    province: this.provinces,
                    participation: this.participations,
                    partnership: this.partnershipNames,
                };
                const item = (_a = prefixToData[prefix]) === null || _a === void 0 ? void 0 : _a.find((i) => this.slugify(i.title) === slug);
                if (item) {
                    if (prefix === 'sector')
                        (_b = this.sectorFilterSelect) === null || _b === void 0 ? void 0 : _b.setChoiceByValue(String(item.id));
                    else if (prefix === 'region')
                        (_c = this.locationFilterSelect) === null || _c === void 0 ? void 0 : _c.setChoiceByValue(String(item.id));
                    else if (prefix === 'province')
                        (_d = this.provincesFilterSelect) === null || _d === void 0 ? void 0 : _d.setChoiceByValue(String(item.id));
                    else if (prefix === 'participation')
                        (_e = this.participationFilterSelect) === null || _e === void 0 ? void 0 : _e.setChoiceByValue(String(item.id));
                    else if (prefix === 'partnership')
                        (_f = this.partnershipNameFilterSelect) === null || _f === void 0 ? void 0 : _f.setChoiceByValue(String(item.id));
                }
            }
        }
    }
};
__decorate([
    Prop({ type: Object })
], ProjectList.prototype, "labels", void 0);
__decorate([
    Prop()
], ProjectList.prototype, "activeSector", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ProjectList.prototype, "propShowOptions", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ProjectList.prototype, "propShowMap", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ProjectList.prototype, "isClickable", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], ProjectList.prototype, "featureProjectId", void 0);
__decorate([
    service.State
], ProjectList.prototype, "projects", void 0);
__decorate([
    service.State
], ProjectList.prototype, "sectors", void 0);
__decorate([
    service.State
], ProjectList.prototype, "locations", void 0);
__decorate([
    service.State
], ProjectList.prototype, "provinces", void 0);
__decorate([
    service.State
], ProjectList.prototype, "participations", void 0);
__decorate([
    service.Action
], ProjectList.prototype, "getProjectBrowserData", void 0);
__decorate([
    Watch('projects')
], ProjectList.prototype, "onDataChanged", null);
__decorate([
    Watch('sectors')
], ProjectList.prototype, "onSectorsChanged", null);
ProjectList = __decorate([
    Component({
        components: {
            Project,
            ProjectMap,
            ProjectDetails,
            Loader
        }
    })
], ProjectList);
export default ProjectList;
